export const environment = {
  production: false,
  BASE_URL: 'https://dev.api.learning.wginb.com/',
  LOGIN_SSO_URL: 'https://dev.api.learning.wginb.com/wglearningbuddylogin/ssologin',
  MSAL_CONFIG: {
    clientId: 'f529d809-fdd8-4726-9659-2fc6c6f8f51d',
    authority: 'https://login.microsoftonline.com/2563c132-88f5-466f-bbb2-e83153b3c808',
    redirectUri: 'https://dev.portal.learning.wginb.com',
    postLogoutRedirectUri: 'https://dev.portal.learning.wginb.com'
  },
  BASE_API: {
    STATIC: 'wglearningbuddy/static',
    VIDEO_LIST: 'wglearningbuddy/video/list',
    VIDEO: 'wglearningbuddy/video',
    COURSE: 'wglearningbuddy/course',
    COURSE_LIST: 'wglearningbuddy/course/list',
    COURSE_ASSIGNED: 'wglearningbuddy/course/assigned',
    EMPLOYEES: 'wglearningbuddy/employees',
    MYTEAM: 'wglearningbuddy/myteam'
  }
};


